module.exports = __webpack_public_path__ + "static/media/resume.a96a1405.pdf";